<template>
  <div class="GlobalFormDemo">
    <GlobalForm
      :init-data="initData"
      :form-item-list="formItemList"
      :inline="true"
      :labelWidth="90"
      :needBtnLoading="true"
      round
      @handleConfirm="handleConfirm"
      confirmBtnName="查询"
    >
      <el-form-item label="订单状态" slot="operationSelect">
        <el-select
          v-model="stateList"
          placeholder="请选择订单状态，可多选"
          clearable
          collapse-tags
          multiple
        >
          <el-option
            v-for="item in stateOptions"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="下单门店" slot="operationSelect">
        <el-select
          filterable
          v-model="storeId"
          placeholder="请选择或输入门店"
          clearable
        >
          <el-option
            v-for="item in storeList"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>
      <div slot="AddSlot">
        <el-button
          size="small"
          type="success"
          icon="el-icon-download"
          :loading="exportLoading"
          @click="clickExcel"
          >导出Excel</el-button
        >
      </div>
    </GlobalForm>
  </div>
</template>

<script>
import _api from "@/utils/request";
import moment from "moment";
export default {
  name: "Form",
  data() {
    return {
      pickerMinDate: null,
      pickerMaxDate: null,
      day31: 30 * 24 * 3600 * 1000,
      companyId: "",
      stateOptions: [],
      storeList: [],
      stateList: [],
      storeId: [],
      initData: {
        entryTime: [
          moment()
            .day(moment().day() - 14)
            .format("YYYY-MM-DD 00:00:00"),
          moment().format("YYYY-MM-DD 23:59:59"),
        ],
      },
      SeachParams: {
        startTime: Date.parse(moment()
          .day(moment().day() - 14)
          .format("YYYY-MM-DD 00:00:00")),
        endTime: Date.parse(moment().format("YYYY-MM-DD 23:59:59")),
      },
      formItemList: [
        { slotName: "operationSelect" },
        {
          key: "customerName",
          type: "input",
          labelName: "客户姓名",
          placeholder: "请输入客户姓名查询",
        },
        {
          key: "customerPhone",
          isNumber: true,
          type: "input",
          labelName: "客户手机号",
          placeholder: "请输入客户手机号查询",
        },
        {
          key: "staffName",
          type: "input",
          labelName: "下单店员",
          placeholder: "请输入下单店员姓名查询",
        },
        {
          key: "orderNo",
          type: "input",
          labelName: "订单号",
          placeholder: "请输入回收单号查询",
        },
        {
          key: "entryTime",
          type: "pickerOptions",
          labelName: "下单时间",
          placeholder: "请选择时间",
          valueFormat: "timestamp",
          pickerOptions: {
            onPick: ({ maxDate, minDate }) => {
              if (minDate && this.pickerMinDate) {
                this.pickerMinDate = null;
              } else if (minDate) {
                this.pickerMinDate = minDate.getTime();
              }
            },
            disabledDate: (time) => {
              if (this.pickerMinDate) {
                return (
                  time.getTime() > this.pickerMinDate + this.day31 ||
                  time.getTime() < this.pickerMinDate - this.day31
                );
              }
              return false;
            },
          },
        },
      ],
      exportLoading: false
    };
  },
  created() {
    _api.orderStateList().then((res) => {
      console.log(res);
      this.stateOptions = res.data;
    });
    _api.getStoreSelectOrder().then((res) => {
      this.storeList = res.data;
    });
  },
  watch: {},
  methods: {
    handleConfirm(data,cd) {
      let SeachParams = {};
      console.log(data);
      let startTime = "";
      let endTime = "";
      startTime = moment(data.entryTime[0]).format("x");
      endTime = moment(data.entryTime[1]).format("x");
      SeachParams = {
        stateList: this.stateList,
        storeId: this.storeId,
        customerName: data && data.customerName ? data.customerName : "",
        customerPhone: data && data.customerPhone ? data.customerPhone : "",
        staffName: data && data.staffName ? data.staffName : "",
        orderNo: data && data.orderNo ? data.orderNo : "",
        startTime: startTime,
        endTime: endTime,
        pageNum: 1,
        pageSize: 10,
      };
      this.SeachParams = JSON.parse(JSON.stringify(SeachParams));
      SeachParams.disuseLoding = () => {
        if (typeof cd === 'function') {
          cd()
        }
      },
      this.$store.commit("tagsView/SEACH_PARAMS", SeachParams);
    },
    clickExcel() {
      let data = {
        ...this.SeachParams,
      };
      this.exportLoading = true

      _api.excelCustomer(data).then((res) => {
        const content = res;
        const blob = new Blob([content]);
        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", () => {
          try {
            let data = JSON.parse(reader.result);
            if (data.code === 0) {
              this.$message.error(data.msg || "导出失败");
            }
          } catch (err) {
            let start = "";
            let end = "";
            if (data.startTime || data.endTime) {
              start = moment(Number(data.startTime)).format("YYYY.MM.DD");
              end = moment(Number(data.endTime)).format("YYYY.MM.DD");
            } else if (data.dateType == "01") {
              start = moment()
                .month("YYYY-MM-DD")
                .format("YYYY.MM.DD");
            } else if (data.dateType == "03") {
              start = moment()
                .weekday(1)
                .format("YYYY.MM.DD");
              end = moment()
                .month("YYYY-MM-DD")
                .format("YYYY.MM.DD");
            } else if (data.dateType == "05") {
              start = moment()
                .startOf("month")
                .format("YYYY.MM.DD");
              end = moment()
                .month("YYYY-MM-DD")
                .format("YYYY.MM.DD");
            }
            console.log(moment().startOf("month"));
            const fileName = `【客户数据】${start || ""}${
              end ? "-" + end : ""
            }.xlsx`;
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
          }
        });
        reader.readAsText(blob, "utf-8");
      }).finally(() => {
            this.exportLoading = false;
          });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo {
}
</style>
